/**
 * Resolves whether a chart should render its legend.
 * @param showLegendProp - explicit prop override
 * @param seriesCount - number of plotted series or pie segments
 * @param inReportContext - true inside {@link ReportThemeProvider}
 * @param chatShowWhenMultiple - chat default: show only when `seriesCount > 1`
 */
export const resolveChartShowLegend = (
  showLegendProp: boolean | undefined,
  seriesCount: number,
  inReportContext: boolean,
  chatShowWhenMultiple: boolean,
): boolean => {
  if (showLegendProp !== undefined) return showLegendProp;
  if (seriesCount < 1) return false;
  if (inReportContext) return true;
  return chatShowWhenMultiple ? seriesCount > 1 : false;
};
